import r from"./define-built-in.js";var t=r,u=function(n,i,f){for(var e in i)t(n,e,i[e],f);return n};export{u as default};
